import React from 'react';
import FormatUtils from 'utils/format';
import { Box, Flex } from '@spothero/ui';
// This is a jsx-ified version of the function formatRatePrice from src/js/utils/spot.js 🧑‍🍳😙🤌
// TODO refactor all uses of formatRatePrice and deprecate
const DisplayPriceFormatted = ({ price, currencyType, textToAppend = '', }) => {
    const { dollars, cents } = FormatUtils.price(Number(price));
    if (textToAppend) {
        return (<Flex alignItems="center" gap="1" pb="1.5" className="DisplayPriceFormatted-container">
                <Box fontSize="md" fontWeight="semibold" color="black" className="DisplayPriceFormatted-CurrencySymbol">
                    {FormatUtils.currencySymbol(currencyType)}
                </Box>
                <Box className="DisplayPriceFormatted-Price">
                    {dollars}
                    {cents ? `.${cents}` : '.00'}
                </Box>
                <Box fontSize="sm" fontWeight="normal" color="black" className="DisplayPriceFormatted-TextToAppend">
                    {textToAppend}
                </Box>
            </Flex>);
    }
    return (<>
            {FormatUtils.currencySymbol(currencyType)}
            {dollars}
            {cents ? `.${cents}` : '.00'}
        </>);
};
export default DisplayPriceFormatted;
